export default "https://cdn-static.gokick.com/assets/27898be65df9afd7cb19e5714fb6a6df6232ba84/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";